// ==========================
// SYKERA — Slide transition global (Be Yours compatible)
// ==========================
(function () {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) return;

  const EXCLUDE = [
    "#shopify-section-header",
    "#shopify-section-footer",
    ".announcement-bar",
    ".header",
    "header",
    "footer"
  ];

  const shouldExclude = (el) => EXCLUDE.some(sel => el.matches(sel) || el.querySelector(sel));

  function getTargets() {
    // Shopify rend quasiment tout sous forme de .shopify-section
    // Certains thèmes n'ont pas <main> comme parent direct, donc on ne se limite PAS à main.
    const nodes = Array.from(document.querySelectorAll(
      ".shopify-section, section[id^='shopify-section-'], [data-section-id]"
    ));

    // Nettoyage + exclusions
    return nodes.filter(el => {
      if (!el || !(el instanceof HTMLElement)) return false;
      if (shouldExclude(el)) return false;
      return true;
    });
  }

  function apply() {
    const targets = getTargets();
    if (!targets.length) return;

    // Ajout de la classe qui déclenche le style CSS
    targets.forEach(el => {
      el.classList.add("sy-slide-global");
    });

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });

    targets.forEach(el => io.observe(el));
  }

  // 1) au chargement
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply);
  } else {
    apply();
  }

  // 2) quand Shopify recharge/ajoute des sections dans l’éditeur
  document.addEventListener("shopify:section:load", apply);
  document.addEventListener("shopify:section:reorder", apply);

})();